
import { ApiProperty } from '@nestjs/swagger'
import { IsArray, IsUUID } from 'class-validator'

export class CheckStudentInTeachingsRequestDto {
  @ApiProperty({ type: 'string', description: 'User ID to check' })
  @IsUUID()
  userId: string

  @ApiProperty({ type: [String], description: 'List of teaching IDs' })
  @IsArray()
  @IsUUID('4', { each: true })
  teachingIds: string[]
}
